import { useState } from "react";
import { CalendarDays, X } from "lucide-react";
import { id as idLocale } from "date-fns/locale";
import { format, parseISO } from "date-fns";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Calendar } from "@/components/ui/calendar";

// Value/onChange use "YYYY-MM-DD"; displayed as dd/mm/yyyy (Indonesia).
export function DateField({ value, onChange, placeholder = "dd/mm/yyyy", testId, min, max }) {
  const [open, setOpen] = useState(false);
  const selected = value ? parseISO(value) : undefined;
  const disabled = [];
  if (min) disabled.push({ before: parseISO(min) });
  if (max) disabled.push({ after: parseISO(max) });
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" className={`date-field ${value ? "has-value" : ""}`} data-testid={testId}>
          <CalendarDays size={14} />
          <span>{selected ? format(selected, "dd/MM/yyyy") : placeholder}</span>
          {value && (
            <i role="button" aria-label="Hapus tanggal" className="date-field-clear" data-testid={`${testId}-clear`}
              onClick={(e) => { e.stopPropagation(); onChange(""); }}><X size={12} /></i>
          )}
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0 date-field-pop" align="start" data-testid={`${testId}-calendar`}>
        <Calendar mode="single" locale={idLocale} weekStartsOn={1} selected={selected} defaultMonth={selected}
          disabled={disabled} initialFocus
          onSelect={(d) => { if (d) { onChange(format(d, "yyyy-MM-dd")); setOpen(false); } }} />
      </PopoverContent>
    </Popover>
  );
}
